import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface ProfileDropdownProps {
  userName: string;
  userEmail?: string;
  userPlan?: string;
  avatarUrl?: string;
}
export const ProfileDropdown = ({
  userName = 'John Doe',
  userEmail = 'john.doe@example.com',
  userPlan = 'Casual User',
  avatarUrl
}: ProfileDropdownProps) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };
  return <div className="relative" data-id="element-125">
      <button onClick={toggleDropdown} className="flex items-center text-[#F5F5F7] hover:bg-[#2C2F33] rounded-lg p-1" data-id="element-126">
        <div className="w-8 h-8 bg-gray-600 rounded-full mr-2" data-id="element-127">
          {avatarUrl && <img src={avatarUrl} alt={userName} className="w-full h-full rounded-full object-cover" data-id="element-128" />}
        </div>
        <ChevronDownIcon size={16} data-id="element-129" />
      </button>
      {showDropdown && <div className="absolute right-0 mt-2 w-56 bg-[#2C2F33] rounded-lg shadow-lg border border-gray-700 z-10" data-id="element-130">
          <div className="p-3 border-b border-gray-700" data-id="element-131">
            <p className="text-[#F5F5F7] font-medium" data-id="element-132">{userName}</p>
            <p className="text-gray-400 text-sm" data-id="element-133">{userEmail}</p>
            <p className="text-[#007BFF] text-sm mt-1" data-id="element-134">{userPlan}</p>
          </div>
          <div className="p-1" data-id="element-135">
            <button className="w-full text-left px-3 py-2 text-[#F5F5F7] hover:bg-[#1A1A1D] rounded-md" data-id="element-136">
              Profile
            </button>
          </div>
          <div className="border-t border-gray-700 p-1" data-id="element-137">
            <button className="w-full text-left px-3 py-2 text-[#F5F5F7] hover:bg-[#1A1A1D] rounded-md" data-id="element-138">
              Billing & Subscription
            </button>
            <button className="w-full text-left px-3 py-2 text-[#F5F5F7] hover:bg-[#1A1A1D] rounded-md" data-id="element-139">
              Get Support
            </button>
          </div>
          <div className="border-t border-gray-700 p-1" data-id="element-140">
            <button className="w-full text-left px-3 py-2 text-[#F5F5F7] hover:bg-[#1A1A1D] rounded-md" data-id="element-141">
              Logout
            </button>
          </div>
        </div>}
    </div>;
};